import SmoothScroll from 'smooth-scroll';

// todo : replace with browser API
const smoothScroll = new SmoothScroll();

// todo : move into a shared function
function handleQuantityChange(form) {
    const selection = [];
    const prices = [];
    const quantityInputs = form.querySelectorAll('.js-quantity');

    quantityInputs.forEach(function (input) {
        const number = parseInt(input.value, 10);
        const price = parseFloat(input.dataset.price);

        if (number > 0) {
            selection.push(`${number} x ${input.dataset.label.trim()}`);

            if (price > 0) {
                prices.push(price * number);
            }
        }
    });

    const quantityPlaceholders = form.querySelectorAll('.js-quantity-placeholder');

    if (quantityPlaceholders.length) {
        quantityPlaceholders.forEach(function (placeholder) {
            placeholder.innerHTML = selection.join(', ');
        });
    }

    const pricePlaceholders = form.querySelectorAll('.js-price-placeholder');

    if (pricePlaceholders.length) {
        if (prices.length > 0) {
            const totalPrice = prices.reduce(function (a, b) {
                return a + b;
            });

            pricePlaceholders.forEach(function (placeholder) {
                placeholder.innerHTML = `Total price: £${totalPrice.toFixed(2)}`;
            });
        }
        else {
            pricePlaceholders.forEach(function (placeholder) {
                placeholder.innerHTML = '';
            });
        }
    }

    const continueButton = form.querySelector('.js-gift-voucher-continue');
    const addToBasketButton = form.querySelector('.js-add-to-basket');

    if (continueButton) {
        continueButton.disabled = !selection.length;
    }

    if (addToBasketButton) {
        addToBasketButton.disabled = !selection.length;
    }
}

function giftVouchers(form) {
    const quantityInputs = form.querySelectorAll('.js-quantity');
    const changeButton = form.querySelector('.js-change');
    const continueButton = form.querySelector('.js-gift-voucher-continue');

    if (continueButton) {
        continueButton.addEventListener('click', function (e) {
            smoothScroll.animateScroll(
                document.getElementById('delivery-method'),
                e.currentTarget,
                {
                    speed: 750,
                    easing: 'easeInOutQuad',
                }
            );
        });
    }

    if (changeButton) {
        changeButton.addEventListener('click', function (e) {
            smoothScroll.animateScroll(
                document.getElementById('product-selection'),
                e.currentTarget,
                {
                    speed: 750,
                    easing: 'easeInOutQuad',
                }
            );
        });
    }

    if (quantityInputs.length) {
        quantityInputs.forEach(function (input) {
            input.addEventListener('change', function () {
                handleQuantityChange(form);
            });
        });
    }
}

export default giftVouchers;
